// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_Time_Local from "../Data.Time.Local/index.js";
import * as Data_UTCTime from "../Data.UTCTime/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Analytics_Types_CheckoutTrackingData from "../Restaumatic.Analytics.Types.CheckoutTrackingData/index.js";
import * as Restaumatic_Countries from "../Restaumatic.Countries/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Restaumatic_Locales from "../Restaumatic.Locales/index.js";
import * as Restaumatic_Orders_Checkout_Types from "../Restaumatic.Orders.Checkout.Types/index.js";
import * as Restaumatic_Orders_Payments_Types from "../Restaumatic.Orders.Payments.Types/index.js";
import * as Restaumatic_Orders_Types_FulfillmentMethodType from "../Restaumatic.Orders.Types.FulfillmentMethodType/index.js";
import * as Restaumatic_Orders_Types_OrderInfo from "../Restaumatic.Orders.Types.OrderInfo/index.js";
import * as Restaumatic_Orders_Types_OrderUUID from "../Restaumatic.Orders.Types.OrderUUID/index.js";
import * as Restaumatic_Orders_Types_PaymentMethod from "../Restaumatic.Orders.Types.PaymentMethod/index.js";
import * as Restaumatic_Promotions_Loyalty_Types_UserLoyalty from "../Restaumatic.Promotions.Loyalty.Types.UserLoyalty/index.js";
import * as Restaumatic_Restaurant_Types_Id from "../Restaumatic.Restaurant.Types.Id/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Eq.eqArray(Data_Eq.eqString));
var eq1 = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Orders_Types_OrderUUID.eqOrderUUID);
var eq3 = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Orders_Payments_Types.eqForm);
var eq4 = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Orders_Checkout_Types.eqCheckoutRequest);
var eq5 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Restaumatic_Orders_Payments_Types.eqPaymentRequest));
var eq6 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Restaumatic_Analytics_Types_CheckoutTrackingData.eqCheckoutTrackingData));
var eq7 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Data_UTCTime.eqUTCTime));
var eq8 = /* #__PURE__ */ Data_Eq.eq(Data_Time_Local.eqTZLabel);
var eq9 = /* #__PURE__ */ Data_Eq.eq(Data_UTCTime.eqUTCTime);
var eq10 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Data_Eq.eqString));
var eq11 = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Orders_Types_OrderInfo.eqOrderInfo);
var eq12 = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Restaurant_Types_Id.eqRestaurantId);
var eq13 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Restaumatic_Promotions_Loyalty_Types_UserLoyalty.eqUserLoyalty));
var eq15 = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Locales.eqLocale);
var eq16 = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Countries.eqCountry);
var eq17 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Eq.eqArray(Restaumatic_Orders_Types_FulfillmentMethodType.eqFulfillmentMethodType));
var eq18 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Eq.eqArray(Restaumatic_Orders_Types_PaymentMethod.eqPaymentMethod));
var ErrorsIsSymbol = {
    reflectSymbol: function () {
        return "Errors";
    }
};
var showRecord = /* #__PURE__ */ Data_Show.showRecord()();
var orderUUIDIsSymbol = {
    reflectSymbol: function () {
        return "orderUUID";
    }
};
var showRecordFieldsCons = /* #__PURE__ */ Data_Show.showRecordFieldsCons(orderUUIDIsSymbol);
var urlIsSymbol = {
    reflectSymbol: function () {
        return "url";
    }
};
var showRecordFieldsConsNil = /* #__PURE__ */ Data_Show.showRecordFieldsConsNil(urlIsSymbol)(Data_Show.showString);
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons(showRecordFieldsConsNil)(Restaumatic_Orders_Types_OrderUUID.showOrderUUID))));
var RedirectIsSymbol = {
    reflectSymbol: function () {
        return "Redirect";
    }
};
var ExternalRedirectIsSymbol = {
    reflectSymbol: function () {
        return "ExternalRedirect";
    }
};
var formIsSymbol = {
    reflectSymbol: function () {
        return "form";
    }
};
var PaymentFormIsSymbol = {
    reflectSymbol: function () {
        return "PaymentForm";
    }
};
var tokenIsSymbol = {
    reflectSymbol: function () {
        return "token";
    }
};
var ApplePayResponseTokenIsSymbol = {
    reflectSymbol: function () {
        return "ApplePayResponseToken";
    }
};
var decodeSingleConstructorAr = /* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr();
var decodeRecordCons = /* #__PURE__ */ Unscramble.decodeRecordCons(orderUUIDIsSymbol)(Restaumatic_Orders_Types_OrderUUID.unscrambleDecodeOrderUUID);
var decodeRecordCons1 = /* #__PURE__ */ Unscramble.decodeRecordCons(urlIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordNil);
var decodeSingleConstructorAr1 = /* #__PURE__ */ decodeSingleConstructorAr(/* #__PURE__ */ decodeRecordCons(decodeRecordCons1));
var checkoutIsSymbol = {
    reflectSymbol: function () {
        return "checkout";
    }
};
var originIsSymbol = {
    reflectSymbol: function () {
        return "origin";
    }
};
var paymentIsSymbol = {
    reflectSymbol: function () {
        return "payment";
    }
};
var trackingIsSymbol = {
    reflectSymbol: function () {
        return "tracking";
    }
};
var PlaceOrderRequestIsSymbol = {
    reflectSymbol: function () {
        return "PlaceOrderRequest";
    }
};
var decodeRecord1 = /* #__PURE__ */ Unscramble.decodeRecord1();
var genericShowConstructor1 = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments);
var PlacedIsSymbol = {
    reflectSymbol: function () {
        return "Placed";
    }
};
var WaitingForPaymentIsSymbol = {
    reflectSymbol: function () {
        return "WaitingForPayment";
    }
};
var nextAvailableDayIsSymbol = {
    reflectSymbol: function () {
        return "nextAvailableDay";
    }
};
var openAtIsSymbol = {
    reflectSymbol: function () {
        return "openAt";
    }
};
var showMaybe = /* #__PURE__ */ Data_Maybe.showMaybe(Data_UTCTime.showUTCTime);
var WaitingForDispatchIsSymbol = {
    reflectSymbol: function () {
        return "WaitingForDispatch";
    }
};
var WaitingForConfirmationIsSymbol = {
    reflectSymbol: function () {
        return "WaitingForConfirmation";
    }
};
var CompletedIsSymbol = {
    reflectSymbol: function () {
        return "Completed";
    }
};
var showMaybe1 = /* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString);
var CancelledIsSymbol = {
    reflectSymbol: function () {
        return "Cancelled";
    }
};
var genericDecodeSumConstruct1 = /* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume);
var decodeMaybe = /* #__PURE__ */ Unscramble.decodeMaybe(Data_UTCTime.unscrambleDecodeUTCTime);
var decodeMaybe1 = /* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeString1);
var orderInfoIsSymbol = {
    reflectSymbol: function () {
        return "orderInfo";
    }
};
var restaurantAddressCityIsSymbol = {
    reflectSymbol: function () {
        return "restaurantAddressCity";
    }
};
var restaurantAddressPostCodeIsSymbol = {
    reflectSymbol: function () {
        return "restaurantAddressPostCode";
    }
};
var restaurantAddressStreetIsSymbol = {
    reflectSymbol: function () {
        return "restaurantAddressStreet";
    }
};
var restaurantApetiloImageIsSymbol = {
    reflectSymbol: function () {
        return "restaurantApetiloImage";
    }
};
var restaurantIdIsSymbol = {
    reflectSymbol: function () {
        return "restaurantId";
    }
};
var restaurantNameIsSymbol = {
    reflectSymbol: function () {
        return "restaurantName";
    }
};
var showRecordFieldsCons1 = /* #__PURE__ */ Data_Show.showRecordFieldsCons(restaurantNameIsSymbol);
var restaurantPhonesIsSymbol = {
    reflectSymbol: function () {
        return "restaurantPhones";
    }
};
var restaurantSlugIsSymbol = {
    reflectSymbol: function () {
        return "restaurantSlug";
    }
};
var siteNameIsSymbol = {
    reflectSymbol: function () {
        return "siteName";
    }
};
var stateIsSymbol = {
    reflectSymbol: function () {
        return "state";
    }
};
var userLoyaltyIsSymbol = {
    reflectSymbol: function () {
        return "userLoyalty";
    }
};
var GetOrderSummaryResponseIsSymbol = {
    reflectSymbol: function () {
        return "GetOrderSummaryResponse";
    }
};
var decodeRecordCons2 = /* #__PURE__ */ Unscramble.decodeRecordCons(restaurantIdIsSymbol)(Restaumatic_Restaurant_Types_Id.udecodeRestaurantId);
var decodeRecordCons3 = /* #__PURE__ */ Unscramble.decodeRecordCons(restaurantNameIsSymbol)(Unscramble.decodeString1);
var orderIdIsSymbol = {
    reflectSymbol: function () {
        return "orderId";
    }
};
var GetOrderSummaryRequestIsSymbol = {
    reflectSymbol: function () {
        return "GetOrderSummaryRequest";
    }
};
var isIosReviewModeIsSymbol = {
    reflectSymbol: function () {
        return "isIosReviewMode";
    }
};
var isQrWaiterOrderIsSymbol = {
    reflectSymbol: function () {
        return "isQrWaiterOrder";
    }
};
var localeIsSymbol = {
    reflectSymbol: function () {
        return "locale";
    }
};
var GetCheckoutInfoRequestIsSymbol = {
    reflectSymbol: function () {
        return "GetCheckoutInfoRequest";
    }
};
var labelIsSymbol = {
    reflectSymbol: function () {
        return "label";
    }
};
var valueIsSymbol = {
    reflectSymbol: function () {
        return "value";
    }
};
var FulfillmentTimeChoiceIsSymbol = {
    reflectSymbol: function () {
        return "FulfillmentTimeChoice";
    }
};
var companyCityIsSymbol = {
    reflectSymbol: function () {
        return "companyCity";
    }
};
var companyNameIsSymbol = {
    reflectSymbol: function () {
        return "companyName";
    }
};
var countryIsSymbol = {
    reflectSymbol: function () {
        return "country";
    }
};
var franchiseNameIsSymbol = {
    reflectSymbol: function () {
        return "franchiseName";
    }
};
var fulfillmentMethodsIsSymbol = {
    reflectSymbol: function () {
        return "fulfillmentMethods";
    }
};
var fulfillmentTimesIsSymbol = {
    reflectSymbol: function () {
        return "fulfillmentTimes";
    }
};
var paylanePublicApiKeyIsSymbol = {
    reflectSymbol: function () {
        return "paylanePublicApiKey";
    }
};
var paymentMethodsIsSymbol = {
    reflectSymbol: function () {
        return "paymentMethods";
    }
};
var signedInIsSymbol = {
    reflectSymbol: function () {
        return "signedIn";
    }
};
var CheckoutInfoIsSymbol = {
    reflectSymbol: function () {
        return "CheckoutInfo";
    }
};
var encodeWithOptionsRecord = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord();
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var encodeRecordCons1 = /* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil);
var encodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode);
var encodeRecordCons2 = /* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons1(urlIsSymbol)(encodeWithOptionsOther));
var encodeWithOptionsOther1 = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Orders_Types_OrderUUID.encodeOrderUUID);
var genericEncodeArgsRecord = /* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(/* #__PURE__ */ encodeRecordCons2(orderUUIDIsSymbol)(encodeWithOptionsOther1)));
var encodeWithOptionsOther2 = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Data_UTCTime.encodeUTCTime));
var encodeWithOptionsOther3 = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Foreign_Generic_Class.stringEncode));
var encodeWithOptionsOther4 = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Restaurant_Types_Id.encodeRestaurantId);
var encodeWithOptionsOther5 = /* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode);
var decodeWithOptionsRecord = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord();
var decodeRecordCons4 = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var decodeRecordCons5 = /* #__PURE__ */ decodeRecordCons4(Foreign_Generic_Class.decodeRecordNil);
var decodeWithOptionsOther = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode);
var decodeRecordCons6 = /* #__PURE__ */ decodeRecordCons4(/* #__PURE__ */ decodeRecordCons5(urlIsSymbol)(decodeWithOptionsOther)());
var decodeWithOptionsOther1 = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Orders_Types_OrderUUID.decodeOrderUUID);
var genericDecodeArgsRecord = /* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(/* #__PURE__ */ decodeRecordCons6(orderUUIDIsSymbol)(decodeWithOptionsOther1)()));
var decodeWithOptionsOther2 = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Data_UTCTime.decodeUTCTime));
var decodeWithOptionsOther3 = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Foreign_Generic_Class.stringDecode));
var decodeWithOptionsOther4 = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Restaurant_Types_Id.decodeRestaurantId);
var decodeWithOptionsOther5 = /* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode);
var Errors = /* #__PURE__ */ (function () {
    function Errors(value0) {
        this.value0 = value0;
    };
    Errors.create = function (value0) {
        return new Errors(value0);
    };
    return Errors;
})();
var Redirect = /* #__PURE__ */ (function () {
    function Redirect(value0) {
        this.value0 = value0;
    };
    Redirect.create = function (value0) {
        return new Redirect(value0);
    };
    return Redirect;
})();
var ExternalRedirect = /* #__PURE__ */ (function () {
    function ExternalRedirect(value0) {
        this.value0 = value0;
    };
    ExternalRedirect.create = function (value0) {
        return new ExternalRedirect(value0);
    };
    return ExternalRedirect;
})();
var PaymentForm = /* #__PURE__ */ (function () {
    function PaymentForm(value0) {
        this.value0 = value0;
    };
    PaymentForm.create = function (value0) {
        return new PaymentForm(value0);
    };
    return PaymentForm;
})();
var ApplePayResponseToken = /* #__PURE__ */ (function () {
    function ApplePayResponseToken(value0) {
        this.value0 = value0;
    };
    ApplePayResponseToken.create = function (value0) {
        return new ApplePayResponseToken(value0);
    };
    return ApplePayResponseToken;
})();
var PlaceOrderRequest = function (x) {
    return x;
};
var Placed = /* #__PURE__ */ (function () {
    function Placed() {

    };
    Placed.value = new Placed();
    return Placed;
})();
var WaitingForPayment = /* #__PURE__ */ (function () {
    function WaitingForPayment() {

    };
    WaitingForPayment.value = new WaitingForPayment();
    return WaitingForPayment;
})();
var WaitingForDispatch = /* #__PURE__ */ (function () {
    function WaitingForDispatch(value0) {
        this.value0 = value0;
    };
    WaitingForDispatch.create = function (value0) {
        return new WaitingForDispatch(value0);
    };
    return WaitingForDispatch;
})();
var WaitingForConfirmation = /* #__PURE__ */ (function () {
    function WaitingForConfirmation() {

    };
    WaitingForConfirmation.value = new WaitingForConfirmation();
    return WaitingForConfirmation;
})();
var Completed = /* #__PURE__ */ (function () {
    function Completed(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Completed.create = function (value0) {
        return function (value1) {
            return new Completed(value0, value1);
        };
    };
    return Completed;
})();
var Cancelled = /* #__PURE__ */ (function () {
    function Cancelled(value0) {
        this.value0 = value0;
    };
    Cancelled.create = function (value0) {
        return new Cancelled(value0);
    };
    return Cancelled;
})();
var GetOrderSummaryResponse = function (x) {
    return x;
};
var GetOrderSummaryRequest = function (x) {
    return x;
};
var GetCheckoutInfoRequest = function (x) {
    return x;
};
var FulfillmentTimeChoice = function (x) {
    return x;
};
var CheckoutInfo = function (x) {
    return x;
};
var toFillFormTypePlaceOrderR = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var toFillFormTypePlaceOrderR1 = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var toFillFormTypeOrderSummar = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var toFillFormTypeGetOrderSum = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var toFillFormTypeGetOrderSum1 = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var toFillFormTypeGetCheckout = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var toFillFormTypeFulfillment = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var toFillFormTypeCheckoutInf = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var rPCSitesPlaceOrderRequest = {};
var rPCSitesGetOrderSummaryRe = {};
var rPCSitesGetCheckoutInfoRe = {};
var rPCMethodNamePlaceOrderRe = {
    rpcMethodName: function (v) {
        return "PlaceOrderRequest";
    }
};
var rPCMethodNameGetOrderSumm = {
    rpcMethodName: function (v) {
        return "GetOrderSummaryRequest";
    }
};
var rPCMethodNameGetCheckoutI = {
    rpcMethodName: function (v) {
        return "GetCheckoutInfoRequest";
    }
};
var newtypePlaceOrderRequest_ = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeGetOrderSummaryRes = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeGetOrderSummaryReq = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeGetCheckoutInfoReq = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeFulfillmentTimeCho = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeCheckoutInfo_ = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldPlaceOrderRequest = function (dictHasField) {
    return dictHasField;
};
var hasFieldGetOrderSummaryRe = function (dictHasField) {
    return dictHasField;
};
var hasFieldGetOrderSummaryRe1 = function (dictHasField) {
    return dictHasField;
};
var hasFieldGetCheckoutInfoRe = function (dictHasField) {
    return dictHasField;
};
var hasFieldFulfillmentTimeCh = function (dictHasField) {
    return dictHasField;
};
var hasFieldCheckoutInfo = function (dictHasField) {
    return dictHasField;
};
var eqPlaceOrderResponse = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Errors && y instanceof Errors) {
                return eq(x.value0)(y.value0);
            };
            if (x instanceof Redirect && y instanceof Redirect) {
                return eq1(x.value0.orderUUID)(y.value0.orderUUID) && x.value0.url === y.value0.url;
            };
            if (x instanceof ExternalRedirect && y instanceof ExternalRedirect) {
                return eq1(x.value0.orderUUID)(y.value0.orderUUID) && x.value0.url === y.value0.url;
            };
            if (x instanceof PaymentForm && y instanceof PaymentForm) {
                return eq3(x.value0.form)(y.value0.form) && eq1(x.value0.orderUUID)(y.value0.orderUUID);
            };
            if (x instanceof ApplePayResponseToken && y instanceof ApplePayResponseToken) {
                return eq1(x.value0.orderUUID)(y.value0.orderUUID) && x.value0.token === y.value0.token && x.value0.url === y.value0.url;
            };
            return false;
        };
    }
};
var eqPlaceOrderRequest = {
    eq: function (x) {
        return function (y) {
            return eq4(x.checkout)(y.checkout) && x.origin === y.origin && eq5(x.payment)(y.payment) && eq6(x.tracking)(y.tracking);
        };
    }
};
var eqOrderSummaryState = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Placed && y instanceof Placed) {
                return true;
            };
            if (x instanceof WaitingForPayment && y instanceof WaitingForPayment) {
                return true;
            };
            if (x instanceof WaitingForDispatch && y instanceof WaitingForDispatch) {
                return eq7(x.value0.nextAvailableDay)(y.value0.nextAvailableDay) && x.value0.openAt === y.value0.openAt;
            };
            if (x instanceof WaitingForConfirmation && y instanceof WaitingForConfirmation) {
                return true;
            };
            if (x instanceof Completed && y instanceof Completed) {
                return eq8(x.value0)(y.value0) && eq9(x.value1)(y.value1);
            };
            if (x instanceof Cancelled && y instanceof Cancelled) {
                return eq10(x.value0)(y.value0);
            };
            return false;
        };
    }
};
var eq19 = /* #__PURE__ */ Data_Eq.eq(eqOrderSummaryState);
var eqGetOrderSummaryResponse = {
    eq: function (x) {
        return function (y) {
            return eq11(x.orderInfo)(y.orderInfo) && x.restaurantAddressCity === y.restaurantAddressCity && eq10(x.restaurantAddressPostCode)(y.restaurantAddressPostCode) && eq10(x.restaurantAddressStreet)(y.restaurantAddressStreet) && eq10(x.restaurantApetiloImage)(y.restaurantApetiloImage) && eq12(x.restaurantId)(y.restaurantId) && x.restaurantName === y.restaurantName && eq10(x.restaurantPhones)(y.restaurantPhones) && eq10(x.restaurantSlug)(y.restaurantSlug) && eq10(x.siteName)(y.siteName) && eq19(x.state)(y.state) && eq13(x.userLoyalty)(y.userLoyalty);
        };
    }
};
var eqGetOrderSummaryRequest = {
    eq: function (x) {
        return function (y) {
            return eq1(x.orderId)(y.orderId);
        };
    }
};
var eqGetCheckoutInfoRequest = {
    eq: function (x) {
        return function (y) {
            return x.isIosReviewMode === y.isIosReviewMode && x.isQrWaiterOrder === y.isQrWaiterOrder && eq15(x.locale)(y.locale) && eq12(x.restaurantId)(y.restaurantId);
        };
    }
};
var eqFulfillmentTimeChoice = {
    eq: function (x) {
        return function (y) {
            return x.label === y.label && eq7(x.value)(y.value);
        };
    }
};
var eq20 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Eq.eqArray(eqFulfillmentTimeChoice));
var eqCheckoutInfo = {
    eq: function (x) {
        return function (y) {
            return x.companyCity === y.companyCity && x.companyName === y.companyName && eq16(x.country)(y.country) && eq10(x.franchiseName)(y.franchiseName) && eq17(x.fulfillmentMethods)(y.fulfillmentMethods) && eq20(x.fulfillmentTimes)(y.fulfillmentTimes) && x.paylanePublicApiKey === y.paylanePublicApiKey && eq18(x.paymentMethods)(y.paymentMethods) && x.restaurantName === y.restaurantName && x.signedIn === y.signedIn;
        };
    }
};
var genericPlaceOrderResponse = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new Errors(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new Redirect(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new ExternalRedirect(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return new PaymentForm(x.value0.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inr))) {
            return new ApplePayResponseToken(x.value0.value0.value0.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.RPC.Sites.Types (line 31, column 1 - line 31, column 91): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Errors) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof Redirect) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof ExternalRedirect) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof PaymentForm) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0))));
        };
        if (x instanceof ApplePayResponseToken) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0))));
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.RPC.Sites.Types (line 31, column 1 - line 31, column 91): " + [ x.constructor.name ]);
    }
};
var showPlaceOrderResponse = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPlaceOrderResponse)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showArray(Data_Show.showString)))(ErrorsIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(RedirectIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor(ExternalRedirectIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(formIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(orderUUIDIsSymbol)(Restaumatic_Orders_Types_OrderUUID.showOrderUUID))(Restaumatic_Orders_Payments_Types.showForm))))(PaymentFormIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ showRecordFieldsCons(/* #__PURE__ */ Data_Show.showRecordFieldsCons(tokenIsSymbol)(showRecordFieldsConsNil)(Data_Show.showString))(Restaumatic_Orders_Types_OrderUUID.showOrderUUID))))(ApplePayResponseTokenIsSymbol))))))
};
var unscrambleDecodePlaceOrderResponse = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericPlaceOrderResponse)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(ErrorsIsSymbol)(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(/* #__PURE__ */ Unscramble.decodeArray1(Unscramble.decodeString1))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(RedirectIsSymbol)(decodeSingleConstructorAr1))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(ExternalRedirectIsSymbol)(decodeSingleConstructorAr1))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(PaymentFormIsSymbol)(/* #__PURE__ */ decodeSingleConstructorAr(/* #__PURE__ */ Unscramble.decodeRecordCons(formIsSymbol)(Restaumatic_Orders_Payments_Types.unscrambleDecodeForm)(/* #__PURE__ */ decodeRecordCons(Unscramble.decodeRecordNil)))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(ApplePayResponseTokenIsSymbol)(/* #__PURE__ */ decodeSingleConstructorAr(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ Unscramble.decodeRecordCons(tokenIsSymbol)(Unscramble.decodeString1)(decodeRecordCons1))))))))))(Unscramble_Generic.defaultOptions)
};
var genericPlaceOrderRequest = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showPlaceOrderRequest = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPlaceOrderRequest)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(checkoutIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(originIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(paymentIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(trackingIsSymbol)(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Analytics_Types_CheckoutTrackingData.showCheckoutTrackingData)))(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Orders_Payments_Types.showPaymentRequest)))(Data_Show.showString))(Restaumatic_Orders_Checkout_Types.showCheckoutRequest))))(PlaceOrderRequestIsSymbol))
};
var unscrambleDecodePlaceOrderRequest = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericPlaceOrderRequest)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ decodeRecord1(/* #__PURE__ */ Unscramble.decodeRecordCons(checkoutIsSymbol)(Restaumatic_Orders_Checkout_Types.unscrambleDecodeCheckoutRequest)(/* #__PURE__ */ Unscramble.decodeRecordCons(originIsSymbol)(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons(paymentIsSymbol)(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Orders_Payments_Types.unscrambleDecodePaymentRequest))(/* #__PURE__ */ Unscramble.decodeRecordCons(trackingIsSymbol)(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Analytics_Types_CheckoutTrackingData.unscrambleDecodeCheckoutTrackingData))(Unscramble.decodeRecordNil))))))))(Unscramble_Generic.defaultOptions)
};
var genericOrderSummaryState = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Placed.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return WaitingForPayment.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new WaitingForDispatch(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return WaitingForConfirmation.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inl)))) {
            return new Completed(x.value0.value0.value0.value0.value0.value0, x.value0.value0.value0.value0.value0.value1);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0.value0 instanceof Data_Generic_Rep.Inr)))) {
            return new Cancelled(x.value0.value0.value0.value0.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.RPC.Sites.Types (line 100, column 1 - line 100, column 89): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Placed) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof WaitingForPayment) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof WaitingForDispatch) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof WaitingForConfirmation) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
        };
        if (x instanceof Completed) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(new Data_Generic_Rep.Product(x.value0, x.value1))))));
        };
        if (x instanceof Cancelled) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0)))));
        };
        throw new Error("Failed pattern match at Restaumatic.Orders.RPC.Sites.Types (line 100, column 1 - line 100, column 89): " + [ x.constructor.name ]);
    }
};
var showOrderSummaryState = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericOrderSummaryState)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor1(PlacedIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor1(WaitingForPaymentIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(nextAvailableDayIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(openAtIsSymbol)(Data_Show.showString))(showMaybe))))(WaitingForDispatchIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor1(WaitingForConfirmationIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsProduct(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Time_Local.showTZLabel))(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_UTCTime.showUTCTime)))(CompletedIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(showMaybe1))(CancelledIsSymbol)))))))
};
var unscrambleDecodeOrderSummaryState = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericOrderSummaryState)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ genericDecodeSumConstruct1(PlacedIsSymbol))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ genericDecodeSumConstruct1(WaitingForPaymentIsSymbol))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(WaitingForDispatchIsSymbol)(/* #__PURE__ */ decodeSingleConstructorAr(/* #__PURE__ */ Unscramble.decodeRecordCons(nextAvailableDayIsSymbol)(decodeMaybe)(/* #__PURE__ */ Unscramble.decodeRecordCons(openAtIsSymbol)(Unscramble.decodeString1)(Unscramble.decodeRecordNil)))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ genericDecodeSumConstruct1(WaitingForConfirmationIsSymbol))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgs1(/* #__PURE__ */ Unscramble_Generic.genericDecodeManyArgsProd(/* #__PURE__ */ Unscramble_Generic.genericDecodeManyArgsArgu(Data_Time_Local.udecodeTZLabel))(/* #__PURE__ */ Unscramble_Generic.genericDecodeManyArgsArgu(Data_UTCTime.unscrambleDecodeUTCTime))))(CompletedIsSymbol))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(CancelledIsSymbol)(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(decodeMaybe1)))))))))(Unscramble_Generic.defaultOptions)
};
var genericGetOrderSummaryResponse = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showGetOrderSummaryResponse = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericGetOrderSummaryResponse)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(orderInfoIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(restaurantAddressCityIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(restaurantAddressPostCodeIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(restaurantAddressStreetIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(restaurantApetiloImageIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(restaurantIdIsSymbol)(/* #__PURE__ */ showRecordFieldsCons1(/* #__PURE__ */ Data_Show.showRecordFieldsCons(restaurantPhonesIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(restaurantSlugIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(siteNameIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(stateIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(userLoyaltyIsSymbol)(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Promotions_Loyalty_Types_UserLoyalty.showUserLoyalty)))(showOrderSummaryState))(showMaybe1))(showMaybe1))(showMaybe1))(Data_Show.showString))(Restaumatic_Restaurant_Types_Id.showRestaurantId))(showMaybe1))(showMaybe1))(showMaybe1))(Data_Show.showString))(Restaumatic_Orders_Types_OrderInfo.showOrderInfo))))(GetOrderSummaryResponseIsSymbol))
};
var unscrambleDecodeGetOrderSummaryResponse = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericGetOrderSummaryResponse)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ decodeRecord1(/* #__PURE__ */ Unscramble.decodeRecordCons(orderInfoIsSymbol)(Restaumatic_Orders_Types_OrderInfo.unscrambleDecodeOrderInfo)(/* #__PURE__ */ Unscramble.decodeRecordCons(restaurantAddressCityIsSymbol)(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons(restaurantAddressPostCodeIsSymbol)(decodeMaybe1)(/* #__PURE__ */ Unscramble.decodeRecordCons(restaurantAddressStreetIsSymbol)(decodeMaybe1)(/* #__PURE__ */ Unscramble.decodeRecordCons(restaurantApetiloImageIsSymbol)(decodeMaybe1)(/* #__PURE__ */ decodeRecordCons2(/* #__PURE__ */ decodeRecordCons3(/* #__PURE__ */ Unscramble.decodeRecordCons(restaurantPhonesIsSymbol)(decodeMaybe1)(/* #__PURE__ */ Unscramble.decodeRecordCons(restaurantSlugIsSymbol)(decodeMaybe1)(/* #__PURE__ */ Unscramble.decodeRecordCons(siteNameIsSymbol)(decodeMaybe1)(/* #__PURE__ */ Unscramble.decodeRecordCons(stateIsSymbol)(unscrambleDecodeOrderSummaryState)(/* #__PURE__ */ Unscramble.decodeRecordCons(userLoyaltyIsSymbol)(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Promotions_Loyalty_Types_UserLoyalty.unscrambleDecodeUserLoyalty))(Unscramble.decodeRecordNil))))))))))))))))(Unscramble_Generic.defaultOptions)
};
var genericGetOrderSummaryRequest = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showGetOrderSummaryRequest = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericGetOrderSummaryRequest)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(orderIdIsSymbol)(Restaumatic_Orders_Types_OrderUUID.showOrderUUID))))(GetOrderSummaryRequestIsSymbol))
};
var unscrambleDecodeGetOrderSummaryRequest = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericGetOrderSummaryRequest)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ decodeRecord1(/* #__PURE__ */ Unscramble.decodeRecordCons(orderIdIsSymbol)(Restaumatic_Orders_Types_OrderUUID.unscrambleDecodeOrderUUID)(Unscramble.decodeRecordNil)))))(Unscramble_Generic.defaultOptions)
};
var genericGetCheckoutInfoRequest = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showGetCheckoutInfoRequest = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericGetCheckoutInfoRequest)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(isIosReviewModeIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(isQrWaiterOrderIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(localeIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(restaurantIdIsSymbol)(Restaumatic_Restaurant_Types_Id.showRestaurantId))(Restaumatic_Locales.showLocale))(Data_Show.showBoolean))(Data_Show.showBoolean))))(GetCheckoutInfoRequestIsSymbol))
};
var unscrambleDecodeGetCheckoutInfoRequest = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericGetCheckoutInfoRequest)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ decodeRecord1(/* #__PURE__ */ Unscramble.decodeRecordCons(isIosReviewModeIsSymbol)(Unscramble.decodeBoolean1)(/* #__PURE__ */ Unscramble.decodeRecordCons(isQrWaiterOrderIsSymbol)(Unscramble.decodeBoolean1)(/* #__PURE__ */ Unscramble.decodeRecordCons(localeIsSymbol)(Restaumatic_Locales.udecodeLocale)(/* #__PURE__ */ decodeRecordCons2(Unscramble.decodeRecordNil))))))))(Unscramble_Generic.defaultOptions)
};
var genericFulfillmentTimeChoice = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showFulfillmentTimeChoice = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericFulfillmentTimeChoice)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(labelIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(valueIsSymbol)(showMaybe))(Data_Show.showString))))(FulfillmentTimeChoiceIsSymbol))
};
var unscrambleDecodeFulfillmentTimeChoice = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericFulfillmentTimeChoice)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ decodeRecord1(/* #__PURE__ */ Unscramble.decodeRecordCons(labelIsSymbol)(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons(valueIsSymbol)(decodeMaybe)(Unscramble.decodeRecordNil))))))(Unscramble_Generic.defaultOptions)
};
var genericCheckoutInfo = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showCheckoutInfo = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericCheckoutInfo)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(companyCityIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(companyNameIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(countryIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(franchiseNameIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(fulfillmentMethodsIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(fulfillmentTimesIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(paylanePublicApiKeyIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(paymentMethodsIsSymbol)(/* #__PURE__ */ showRecordFieldsCons1(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(signedInIsSymbol)(Data_Show.showBoolean))(Data_Show.showString))(/* #__PURE__ */ Data_Show.showArray(Restaumatic_Orders_Types_PaymentMethod.showPaymentMethod)))(Data_Show.showString))(/* #__PURE__ */ Data_Show.showArray(showFulfillmentTimeChoice)))(/* #__PURE__ */ Data_Show.showArray(Restaumatic_Orders_Types_FulfillmentMethodType.showFulfillmentMethodType)))(showMaybe1))(Restaumatic_Countries.showCountry))(Data_Show.showString))(Data_Show.showString))))(CheckoutInfoIsSymbol))
};
var unscrambleDecodeCheckoutInfo = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericCheckoutInfo)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ decodeRecord1(/* #__PURE__ */ Unscramble.decodeRecordCons(companyCityIsSymbol)(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons(companyNameIsSymbol)(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons(countryIsSymbol)(Restaumatic_Countries.unscrambleDecodeCountry)(/* #__PURE__ */ Unscramble.decodeRecordCons(franchiseNameIsSymbol)(decodeMaybe1)(/* #__PURE__ */ Unscramble.decodeRecordCons(fulfillmentMethodsIsSymbol)(/* #__PURE__ */ Unscramble.decodeArray1(Restaumatic_Orders_Types_FulfillmentMethodType.unscrambleDecodeFulfillmentMethodType))(/* #__PURE__ */ Unscramble.decodeRecordCons(fulfillmentTimesIsSymbol)(/* #__PURE__ */ Unscramble.decodeArray1(unscrambleDecodeFulfillmentTimeChoice))(/* #__PURE__ */ Unscramble.decodeRecordCons(paylanePublicApiKeyIsSymbol)(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons(paymentMethodsIsSymbol)(/* #__PURE__ */ Unscramble.decodeArray1(Restaumatic_Orders_Types_PaymentMethod.unscrambleDecodePaymentMethod))(/* #__PURE__ */ decodeRecordCons3(/* #__PURE__ */ Unscramble.decodeRecordCons(signedInIsSymbol)(Unscramble.decodeBoolean1)(Unscramble.decodeRecordNil))))))))))))))(Unscramble_Generic.defaultOptions)
};
var encodePlaceOrderResponse = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericPlaceOrderResponse)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ErrorsIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Foreign_Generic_Class.stringEncode)))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(RedirectIsSymbol)(genericEncodeArgsRecord))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ExternalRedirectIsSymbol)(genericEncodeArgsRecord))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(PaymentFormIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons1(orderUUIDIsSymbol)(encodeWithOptionsOther1))(formIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Orders_Payments_Types.encodeForm))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(ApplePayResponseTokenIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons2(tokenIsSymbol)(encodeWithOptionsOther))(orderUUIDIsSymbol)(encodeWithOptionsOther1)))))))))
};
var encodePlaceOrderRequest = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericPlaceOrderRequest)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(PlaceOrderRequestIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons1(trackingIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Analytics_Types_CheckoutTrackingData.encodeCheckoutTrackingData))))(paymentIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Orders_Payments_Types.encodePaymentRequest))))(originIsSymbol)(encodeWithOptionsOther))(checkoutIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Orders_Checkout_Types.encodeCheckoutRequest))))))
};
var encodeOrderSummaryState = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericOrderSummaryState)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(PlacedIsSymbol)(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(WaitingForPaymentIsSymbol)(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(WaitingForDispatchIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons1(openAtIsSymbol)(encodeWithOptionsOther))(nextAvailableDayIsSymbol)(encodeWithOptionsOther2)))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(WaitingForConfirmationIsSymbol)(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(CompletedIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsProduct(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Time_Local.encodeTZLabel)))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_UTCTime.encodeUTCTime)))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(CancelledIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(encodeWithOptionsOther3))))))))
};
var encodeGetOrderSummaryResponse = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericGetOrderSummaryResponse)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(GetOrderSummaryResponseIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons1(userLoyaltyIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Promotions_Loyalty_Types_UserLoyalty.encodeUserLoyalty))))(stateIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeOrderSummaryState)))(siteNameIsSymbol)(encodeWithOptionsOther3))(restaurantSlugIsSymbol)(encodeWithOptionsOther3))(restaurantPhonesIsSymbol)(encodeWithOptionsOther3))(restaurantNameIsSymbol)(encodeWithOptionsOther))(restaurantIdIsSymbol)(encodeWithOptionsOther4))(restaurantApetiloImageIsSymbol)(encodeWithOptionsOther3))(restaurantAddressStreetIsSymbol)(encodeWithOptionsOther3))(restaurantAddressPostCodeIsSymbol)(encodeWithOptionsOther3))(restaurantAddressCityIsSymbol)(encodeWithOptionsOther))(orderInfoIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Orders_Types_OrderInfo.encodeOrderInfo))))))
};
var encodeGetOrderSummaryRequest = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericGetOrderSummaryRequest)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(GetOrderSummaryRequestIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(/* #__PURE__ */ encodeRecordCons1(orderIdIsSymbol)(encodeWithOptionsOther1)))))
};
var encodeGetCheckoutInfoRequest = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericGetCheckoutInfoRequest)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(GetCheckoutInfoRequestIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons1(restaurantIdIsSymbol)(encodeWithOptionsOther4))(localeIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Locales.encodeLocale)))(isQrWaiterOrderIsSymbol)(encodeWithOptionsOther5))(isIosReviewModeIsSymbol)(encodeWithOptionsOther5)))))
};
var encodeFulfillmentTimeChoice = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericFulfillmentTimeChoice)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(FulfillmentTimeChoiceIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons1(valueIsSymbol)(encodeWithOptionsOther2))(labelIsSymbol)(encodeWithOptionsOther)))))
};
var encodeCheckoutInfo = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericCheckoutInfo)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(CheckoutInfoIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ encodeWithOptionsRecord(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons1(signedInIsSymbol)(encodeWithOptionsOther5))(restaurantNameIsSymbol)(encodeWithOptionsOther))(paymentMethodsIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Restaumatic_Orders_Types_PaymentMethod.encodePaymentMethod))))(paylanePublicApiKeyIsSymbol)(encodeWithOptionsOther))(fulfillmentTimesIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(encodeFulfillmentTimeChoice))))(fulfillmentMethodsIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Restaumatic_Orders_Types_FulfillmentMethodType.encodeFulfillmentMethodType))))(franchiseNameIsSymbol)(encodeWithOptionsOther3))(countryIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Countries.encodeCountry)))(companyNameIsSymbol)(encodeWithOptionsOther))(companyCityIsSymbol)(encodeWithOptionsOther)))))
};
var decodePlaceOrderResponse = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericPlaceOrderResponse)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ErrorsIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Foreign_Generic_Class.stringDecode))))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(RedirectIsSymbol)(genericDecodeArgsRecord)(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ExternalRedirectIsSymbol)(genericDecodeArgsRecord)(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(PaymentFormIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(/* #__PURE__ */ decodeRecordCons4(/* #__PURE__ */ decodeRecordCons5(orderUUIDIsSymbol)(decodeWithOptionsOther1)())(formIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Orders_Payments_Types.decodeForm))())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(ApplePayResponseTokenIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(/* #__PURE__ */ decodeRecordCons4(/* #__PURE__ */ decodeRecordCons6(tokenIsSymbol)(decodeWithOptionsOther)())(orderUUIDIsSymbol)(decodeWithOptionsOther1)())))(Foreign_Generic_Class.genericCountArgsArgument))))))
};
var decodePlaceOrderRequest = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericPlaceOrderRequest)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(PlaceOrderRequestIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(/* #__PURE__ */ decodeRecordCons4(/* #__PURE__ */ decodeRecordCons4(/* #__PURE__ */ decodeRecordCons4(/* #__PURE__ */ decodeRecordCons5(trackingIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Analytics_Types_CheckoutTrackingData.decodeCheckoutTrackingData)))())(paymentIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Orders_Payments_Types.decodePaymentRequest)))())(originIsSymbol)(decodeWithOptionsOther)())(checkoutIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Orders_Checkout_Types.decodeCheckoutRequest))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var decodeOrderSummaryState = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericOrderSummaryState)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(PlacedIsSymbol)(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(WaitingForPaymentIsSymbol)(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(WaitingForDispatchIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(/* #__PURE__ */ decodeRecordCons4(/* #__PURE__ */ decodeRecordCons5(openAtIsSymbol)(decodeWithOptionsOther)())(nextAvailableDayIsSymbol)(decodeWithOptionsOther2)())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(WaitingForConfirmationIsSymbol)(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(CompletedIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsProduct(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Time_Local.decodeTZLabel)))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_UTCTime.decodeUTCTime))))(/* #__PURE__ */ Foreign_Generic_Class.genericCountArgsProduct(Foreign_Generic_Class.genericCountArgsArgument)(Foreign_Generic_Class.genericCountArgsArgument)))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(CancelledIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(decodeWithOptionsOther3))(Foreign_Generic_Class.genericCountArgsArgument)))))))
};
var decodeGetOrderSummaryResponse = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericGetOrderSummaryResponse)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(GetOrderSummaryResponseIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(/* #__PURE__ */ decodeRecordCons4(/* #__PURE__ */ decodeRecordCons4(/* #__PURE__ */ decodeRecordCons4(/* #__PURE__ */ decodeRecordCons4(/* #__PURE__ */ decodeRecordCons4(/* #__PURE__ */ decodeRecordCons4(/* #__PURE__ */ decodeRecordCons4(/* #__PURE__ */ decodeRecordCons4(/* #__PURE__ */ decodeRecordCons4(/* #__PURE__ */ decodeRecordCons4(/* #__PURE__ */ decodeRecordCons4(/* #__PURE__ */ decodeRecordCons5(userLoyaltyIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Promotions_Loyalty_Types_UserLoyalty.decodeUserLoyalty)))())(stateIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeOrderSummaryState))())(siteNameIsSymbol)(decodeWithOptionsOther3)())(restaurantSlugIsSymbol)(decodeWithOptionsOther3)())(restaurantPhonesIsSymbol)(decodeWithOptionsOther3)())(restaurantNameIsSymbol)(decodeWithOptionsOther)())(restaurantIdIsSymbol)(decodeWithOptionsOther4)())(restaurantApetiloImageIsSymbol)(decodeWithOptionsOther3)())(restaurantAddressStreetIsSymbol)(decodeWithOptionsOther3)())(restaurantAddressPostCodeIsSymbol)(decodeWithOptionsOther3)())(restaurantAddressCityIsSymbol)(decodeWithOptionsOther)())(orderInfoIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Orders_Types_OrderInfo.decodeOrderInfo))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var decodeGetOrderSummaryRequest = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericGetOrderSummaryRequest)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(GetOrderSummaryRequestIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(/* #__PURE__ */ decodeRecordCons5(orderIdIsSymbol)(decodeWithOptionsOther1)())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var decodeGetCheckoutInfoRequest = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericGetCheckoutInfoRequest)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(GetCheckoutInfoRequestIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(/* #__PURE__ */ decodeRecordCons4(/* #__PURE__ */ decodeRecordCons4(/* #__PURE__ */ decodeRecordCons4(/* #__PURE__ */ decodeRecordCons5(restaurantIdIsSymbol)(decodeWithOptionsOther4)())(localeIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Locales.decodeLocale))())(isQrWaiterOrderIsSymbol)(decodeWithOptionsOther5)())(isIosReviewModeIsSymbol)(decodeWithOptionsOther5)())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var decodeFulfillmentTimeChoice = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericFulfillmentTimeChoice)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(FulfillmentTimeChoiceIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(/* #__PURE__ */ decodeRecordCons4(/* #__PURE__ */ decodeRecordCons5(valueIsSymbol)(decodeWithOptionsOther2)())(labelIsSymbol)(decodeWithOptionsOther)())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var decodeCheckoutInfo = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericCheckoutInfo)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(CheckoutInfoIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ decodeWithOptionsRecord(/* #__PURE__ */ decodeRecordCons4(/* #__PURE__ */ decodeRecordCons4(/* #__PURE__ */ decodeRecordCons4(/* #__PURE__ */ decodeRecordCons4(/* #__PURE__ */ decodeRecordCons4(/* #__PURE__ */ decodeRecordCons4(/* #__PURE__ */ decodeRecordCons4(/* #__PURE__ */ decodeRecordCons4(/* #__PURE__ */ decodeRecordCons4(/* #__PURE__ */ decodeRecordCons5(signedInIsSymbol)(decodeWithOptionsOther5)())(restaurantNameIsSymbol)(decodeWithOptionsOther)())(paymentMethodsIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Restaumatic_Orders_Types_PaymentMethod.decodePaymentMethod)))())(paylanePublicApiKeyIsSymbol)(decodeWithOptionsOther)())(fulfillmentTimesIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(decodeFulfillmentTimeChoice)))())(fulfillmentMethodsIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Restaumatic_Orders_Types_FulfillmentMethodType.decodeFulfillmentMethodType)))())(franchiseNameIsSymbol)(decodeWithOptionsOther3)())(countryIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Countries.decodeCountry))())(companyNameIsSymbol)(decodeWithOptionsOther)())(companyCityIsSymbol)(decodeWithOptionsOther)())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    Errors,
    Redirect,
    ExternalRedirect,
    PaymentForm,
    ApplePayResponseToken,
    PlaceOrderRequest,
    Placed,
    WaitingForPayment,
    WaitingForDispatch,
    WaitingForConfirmation,
    Completed,
    Cancelled,
    GetOrderSummaryResponse,
    GetOrderSummaryRequest,
    GetCheckoutInfoRequest,
    FulfillmentTimeChoice,
    CheckoutInfo,
    genericPlaceOrderResponse,
    eqPlaceOrderResponse,
    showPlaceOrderResponse,
    encodePlaceOrderResponse,
    decodePlaceOrderResponse,
    unscrambleDecodePlaceOrderResponse,
    toFillFormTypePlaceOrderR1,
    genericPlaceOrderRequest,
    eqPlaceOrderRequest,
    showPlaceOrderRequest,
    rPCMethodNamePlaceOrderRe,
    rPCSitesPlaceOrderRequest,
    encodePlaceOrderRequest,
    decodePlaceOrderRequest,
    unscrambleDecodePlaceOrderRequest,
    toFillFormTypePlaceOrderR,
    hasFieldPlaceOrderRequest,
    newtypePlaceOrderRequest_,
    genericOrderSummaryState,
    eqOrderSummaryState,
    showOrderSummaryState,
    encodeOrderSummaryState,
    decodeOrderSummaryState,
    unscrambleDecodeOrderSummaryState,
    toFillFormTypeOrderSummar,
    genericGetOrderSummaryResponse,
    eqGetOrderSummaryResponse,
    showGetOrderSummaryResponse,
    encodeGetOrderSummaryResponse,
    decodeGetOrderSummaryResponse,
    unscrambleDecodeGetOrderSummaryResponse,
    toFillFormTypeGetOrderSum1,
    hasFieldGetOrderSummaryRe1,
    newtypeGetOrderSummaryRes,
    genericGetOrderSummaryRequest,
    eqGetOrderSummaryRequest,
    showGetOrderSummaryRequest,
    rPCMethodNameGetOrderSumm,
    rPCSitesGetOrderSummaryRe,
    encodeGetOrderSummaryRequest,
    decodeGetOrderSummaryRequest,
    unscrambleDecodeGetOrderSummaryRequest,
    toFillFormTypeGetOrderSum,
    hasFieldGetOrderSummaryRe,
    newtypeGetOrderSummaryReq,
    genericGetCheckoutInfoRequest,
    eqGetCheckoutInfoRequest,
    showGetCheckoutInfoRequest,
    rPCMethodNameGetCheckoutI,
    rPCSitesGetCheckoutInfoRe,
    encodeGetCheckoutInfoRequest,
    decodeGetCheckoutInfoRequest,
    unscrambleDecodeGetCheckoutInfoRequest,
    toFillFormTypeGetCheckout,
    hasFieldGetCheckoutInfoRe,
    newtypeGetCheckoutInfoReq,
    genericFulfillmentTimeChoice,
    eqFulfillmentTimeChoice,
    showFulfillmentTimeChoice,
    encodeFulfillmentTimeChoice,
    decodeFulfillmentTimeChoice,
    unscrambleDecodeFulfillmentTimeChoice,
    toFillFormTypeFulfillment,
    hasFieldFulfillmentTimeCh,
    newtypeFulfillmentTimeCho,
    genericCheckoutInfo,
    eqCheckoutInfo,
    showCheckoutInfo,
    encodeCheckoutInfo,
    decodeCheckoutInfo,
    unscrambleDecodeCheckoutInfo,
    toFillFormTypeCheckoutInf,
    hasFieldCheckoutInfo,
    newtypeCheckoutInfo_
};
